import 'document-register-element';
import React from 'react';
import ReactDOM from 'react-dom';

import SiteHeader from '@homeaway/react-site-header';
import SiteFooter from '@homeaway/react-site-footer';

import utility from '../../helpers/utility';
import message from 'framework/modules/message';

const feedbackComponentTranslations = {
    'reactFeedback.tabText': message.read('shared.stabFeedback.tabText'),
    'reactFeedback.title': message.read('shared.stabFeedback.tabText'),
    'reactFeedback.reviewLink': message.read('shared.stabFeedback.reviewLink'),
    'reactFeedback.reviewLinkText': message.read(
        'shared.stabFeedback.lookingToWriteReview'
    ),
    'reactFeedback.helpLink': message.read('shared.stabFeedback.helpLink'),
    'reactFeedback.helpLinkText': message.read(
        'shared.stabFeedback.lookingForSupport'
    ),
    'reactFeedback.supportLinkText': message.read(
        'shared.stabFeedback.leaveComment'
    ),
    'reactFeedback.externalLinkSrText': message.read(
        'shared.stabFeedback.externalLinkSrText'
    ),
};

const SiteHeaderConnector = SiteHeader.default;
const {currency, fullLocale, name, theme} = window.__SITE_CONTEXT__;

if (!utility.isNativeMobileRequest()) {
    ReactDOM.render(
        <SiteHeaderConnector
            currencyCode={currency}
            dataUrl={'/cko/api'}
            feedbackComponentLingua={feedbackComponentTranslations}
            feedbackComponentTranslations={feedbackComponentTranslations}
            fullLocale={fullLocale}
            openLinksInNewWindow
            siteName={name}
            theme={theme}
            withoutAccessibility
            withoutAppButton
            withoutCountryLanguageSelector
            withoutCurrencySelector
            withoutFlags
            withoutHelpLinks
            withoutInbox
            withoutListYourProperty
            withoutLogin
            withoutScratchpad
            withoutSearch
            withoutSignUp
            withoutTraveler
        />,
        document.getElementById('homeaway-header')
    );

    ReactDOM.render(
        <SiteFooter.default dataUrl={'/cko/api/footer'} site={name} isMobile />,
        document.getElementById('footer')
    );
}
